import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useState } from 'react';

interface PROPS {
  title: string;
  children: JSX.Element;
}

export function G_GRAPH_NODE__table_wrapper({ title, children }: PROPS) {
  /*
   * STATE
   */
  const [is_hovered, set_is_hovered] = useState(false);

  /*
   * RENDERS
   */
  function render_table_header() {
    return (
      <div
        className="flex flex-row items-center gap-2 w-full bg-bar shadow-[0_1px_0_0_theme(colors.gray.600)] text-xs text-gray-400 font-medium text-left"
        style={{ height: `${CONSTANTS__shared.GRID_CELL_SIZE * 2}px` }}
      >
        <div className="w-0" />
        <div className="w-32 min-w-32 max-w-32">name</div>
        <div className="w-24 min-w-24 max-w-24">hash full</div>
        <div className="w-24 min-w-24 max-w-24">hash core</div>
        <div className="w-20 min-w-24 max-w-24">value</div>
        <div className="w-20 min-w-24 max-w-24">type</div>
        <div className="w-20 min-w-24 max-w-24">actions</div>
        <div className="w-0" />
      </div>
    );
  }

  /*
   * HTML
   */
  return (
    <div onMouseEnter={() => set_is_hovered(true)} onMouseLeave={() => set_is_hovered(false)}>
      <div
        className="flex flex-col flex-center shadow-[0_-0.5px_0_0_theme(colors.gray.600)] bg-bar"
        style={{ height: `${CONSTANTS__shared.GRID_CELL_SIZE * 2}px` }}
      >
        {!is_hovered && <span className=" text-xs text-gray-400 font-medium text-center ">{title}</span>}
        {is_hovered && render_table_header()}
      </div>
      {children}
    </div>
  );
}
